function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import ProductsHorizontalTimerTabsComponent from "segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-component.js";
import Title from "segments/desktop/core-components/title/title";
import { ALIGN_TYPES } from "constants/align-types";
import { UI_BORDER_LIGHT_COLOR_NAME } from "styles/color-consts";
import ProductTagsComponent from "./product-tags-component/product-tags-component";
import DefaultProps from "./default-props";
import { useEffect } from "react";
import { StyledTagsByProductHomepageFirstFoldComponent } from "./tags-by-product-homepage-first-fold-component.scss";
const TagsByProductHomepageFirstFoldComponent = (props)=>{
    const { tabs, fullParagraph, fullParagraphAdvancedConfig, subTitle, subTitleAdvancedConfig, tabsPaddingTop, isV2, excludeFromWMHighIntentExperienceTest, translate, setIsFirstFoldVisible, setStartShowingContactSalesButton, isInView } = props;
    useEffect(()=>{
        if (isInView === true) {
            setStartShowingContactSalesButton(true);
        }
        setIsFirstFoldVisible(isInView);
    }, [
        setIsFirstFoldVisible,
        isInView,
        setStartShowingContactSalesButton
    ]);
    const contentRenderer = (currentTab)=>{
        return /*#__PURE__*/ _jsx(ProductTagsComponent, {
            currentTab: currentTab,
            isV2: isV2,
            excludeFromWMHighIntentExperienceTest: excludeFromWMHighIntentExperienceTest,
            translate: translate
        });
    };
    return /*#__PURE__*/ _jsxs(StyledTagsByProductHomepageFirstFoldComponent, {
        className: "tags-by-product-homepage-first-fold-component",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "paragraph-wrapper",
                children: [
                    /*#__PURE__*/ _jsx(FullParagraph, _object_spread_props(_object_spread({}, fullParagraphAdvancedConfig, fullParagraph), {
                        topic: {},
                        textAlign: ALIGN_TYPES.CENTER,
                        titleClassName: "universe-title"
                    })),
                    (subTitle === null || subTitle === void 0 ? void 0 : subTitle.title) && /*#__PURE__*/ _jsx(Title, _object_spread_props(_object_spread({}, subTitle, subTitleAdvancedConfig), {
                        titleClassName: "sub-title"
                    }))
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "product-tabs-wrapper",
                style: {
                    paddingTop: tabsPaddingTop
                },
                children: /*#__PURE__*/ _jsx(ProductsHorizontalTimerTabsComponent, {
                    contentRenderer: contentRenderer,
                    overrideTabs: tabs,
                    tabsTitle: {},
                    progressbarColor: UI_BORDER_LIGHT_COLOR_NAME,
                    renderDesktopTabsOnly: true
                })
            })
        ]
    });
};
TagsByProductHomepageFirstFoldComponent.defaultProps = DefaultProps;
export default TagsByProductHomepageFirstFoldComponent;
